import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rightAngle",
  "use": "icon-rightAngle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rightAngle\"><path d=\"M881.57 855.552H432.176V618.729c0-14.383-11.637-26.042-26.043-26.042H168.448V142.429a26.042 26.042 0 10-52.084 0v739.188c0 14.36 11.636 26.02 26.065 26.02h739.142a26.042 26.042 0 100-52.085zm-712.238 0V644.771H380.09v210.781H169.332z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol